module.exports = __webpack_public_path__ + "img/story004@2x.c7b0b48a.webp";